import React from 'react'
import {Route, Redirect} from "react-router-dom";
import {connect} from "react-redux";

const ProtectedRoute = ({user, dispatch, ...restProps}) => {
    if(!user.token){
        localStorage.clear();
        return <Redirect to={process.env.REACT_APP_NAME === 'store' ? "/login" : "/"} />
    }
    return <Route {...restProps}/>
}

export default connect((state) => ({user: state.loginReducer.data}))(ProtectedRoute)